<div class="layout-wrapper" [ngClass]="containerClass">
    <app-admin-header />
    <app-admin-sidebar />

    <div class="layout-main-container">
        <div class="layout-main">
            <router-outlet />
        </div>
        <app-admin-footer />
    </div>

    <div class="layout-mask"></div>
</div>
